export const TestHooks = {
	FontDropdown: 'font-dropdown',
} as const;
